import React, { useState, useEffect } from "react";
import axios from "axios";
import { Button, Card, Form, Modal, Table } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { Icon } from "@iconify/react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { reportDetail, sendMail,markResolve } from "../../../api/revenueService";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { reportSchema } from "../../../validations/authSchema";
export default function Viewreport() {
  const [report, setReport] = useState({});
  const { reportId } = useParams();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(reportSchema),
  });

  useEffect(() => {
    if (reportId) {
      fetchUser(reportId);
    }
  }, [reportId]);

  const fetchUser = (reportId) => {
    reportDetail({ reportId })
      .then((response) => {
        if (response.data) {
          setReport(response.data);
        }
      })
      .catch((error) => console.error("Error fetching user details", error));
  };

  const userinfo = {
    ReportID: report._id,
    Reporter: report.reportFrom,
    Reason: report.description,
    status: report.status,
  };

  const Taledata = [
    {
      id: 1,
      TaleName: report.tale,
      Genre: report.genre,
      Likes: "5,4k",
      Comments: "2,4k",
    },
  ];

  const [showSecondDiv, setShowSecondDiv] = useState(false);
  const [sent, setSent] = useState(false);
  const senttoggle = () => setSent(!sent);
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  // const [report, seteport] = useState({});
  const [content, setContent] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleSendClick = () => {
    setShowSecondDiv(true);
    setShow(false);
  };


  const handleSendMessage = async (data) => {
    try {
      data.email = email;
      data.reportId = report._id;
      const response = await sendMail(data);
      if (response.code === 200) {
      toast.success(response.message);
      setSent(false);
      setEmail("");
      setSubject("");
      setContent("");
    }else{
        toast.error(response.message);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleOpenSendMessage = () => {
    setEmail(report.email);
    setSent(true);
  };

  const handleMarkAsResolve = () => {
    markResolve({reportId:report._id})
      .then((response) => {
        if (response.status == true) {
          toast.success("Resolved successfully");
          setReport((prevSupport) => ({
            ...prevSupport,
            status: "Resolved",
          }));
        }
      })
      .catch((error) => {
        console.error("Error marking as resolved", error);
        alert("Failed to mark as resolved. Please try again.");
      });
  };

  return (
    <React.Fragment>
      <Card>
        <Card.Header className="d-flex align-items-center justify-content-between flex-wrap">
          <h5>Report Details</h5>
          <Link
            className="btn btn-primary-light d-inline-flex align-items-center justify-content-center px-4 min_width140"
            to="/reports"
          >
            Back
          </Link>
        </Card.Header>
        <Card.Body className="bookingtable mt-3">
          <div className="viewtable_box">
            <Table>
              <thead>
                <tr>
                  <th>Tale Name</th>
                  <th>Genre</th>
                  <th>Likes</th>
                  <th>Comments</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {Taledata.map((item, index) => (
                  <tr key={index}>
                    <td>{item.TaleName}</td>
                    <td>{item.Genre}</td>
                    <td>{item.Likes}</td>
                    <td>{item.Comments}</td>
                    <td>
                      <Link
                        className="btnview"
                        to={`/admin/tale-detail/${report.taleId}`}
                      >
                        <Icon icon="tabler:eye"></Icon>
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          <Table responsive>
            <tbody>
              <tr>
                <td>
                  <b>Report ID</b>
                </td>
                <td>{userinfo.ReportID}</td>
              </tr>
              <tr>
                <td>
                  <b>Reporter</b>
                </td>
                <td>{userinfo.Reporter}</td>
              </tr>
              <tr>
                <td>
                  <b>Reason</b>
                </td>
                <td>{userinfo.Reason}</td>
              </tr>
              <tr>
                <td>
                  <b>Status</b>
                </td>
                <td>
                  {" "}
                  <span className="Active badge">{report.status}</span>
                </td>
              </tr>
            </tbody>
          </Table>
          {/* {showSecondDiv && ( */}
          <div className="reportresponse_div">
            <h3 className="reportresponse_head">Response History</h3>
            <div className="reportresponse_box">
              {report.adminReply ? (
                <>
                  <h4>Admin Reply</h4>
                  <p>{report.adminReply}</p>
                </>
              ) : (
                <p>No reply yet</p>
              )}
            </div>
          </div>
          {/* )}           */}
          <div className="mt-3">
            <Button
              className="btn btn-primary-outline px-4 mt-2 me-2 min_width140"
              onClick={handleOpenSendMessage}
            >
              Reply
            </Button>
            <Button
              className="btn btn-primary px-4 mt-2 min_width140"
              onClick={handleMarkAsResolve}
            >
              Mark As Resolve
            </Button>
          </div>

          <Modal show={sent} onHide={senttoggle} centered>
            <Modal.Header closeButton>
              <Modal.Title>
                <h2 className="modalhead">Send Message</h2>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form onSubmit={handleSubmit(handleSendMessage)}>
                <Form.Group className="mb-3 form-group">
                  <Form.Label>Subject</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter subject"
                    {...register("subject")}
                  />
                  {errors.subject && (
                    <p className="text-danger">{errors.subject.message}</p>
                  )}
                </Form.Group>
                <Form.Group className="mb-3 form-group">
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    placeholder="Enter message"
                    {...register("content")}
                  />
                  {errors.content && (
                    <p className="text-danger">{errors.content.message}</p>
                  )}
                </Form.Group>
                <Button
                  onClick={senttoggle}
                  className="btn btn-secondary px-4 min_width110"
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  className="btn btn-primary px-4 mx-2 min_width110"
                >
                  Send
                </Button>
              </Form>
            </Modal.Body>
          </Modal>
        </Card.Body>
      </Card>
      <ToastContainer />
    </React.Fragment>
  );
}
